<main>
  <div>
    <form class="book-a-call-form" [formGroup]="bookACallForm" (ngSubmit)="$event.preventDefault()">
      <div [hidden]="bookACallFormStep !== 'timeline'">
        <span class="lib-spacer"></span>
        <div>
          <h3>{{timelineQuestion}}</h3>
          <p class="lib-legend">First things first, help us understand your timeline.</p>
          <div>
            <div class="timeline">
              <div class="input">
                <div *ngFor="let option of timelineOptions; index as i" [hidden]="i === 0">
                  <input type="radio" [id]="'timeline'+i" name="timeline" formControlName="timeline"
                    [value]="option.value">
                </div>
              </div>
              <div class="line">
                <div *ngFor="let option of timelineOptions; index as i" [hidden]="i === 0">
                  <label class="lib-legend" [for]="'timeline'+i">{{option.label}}</label>
                </div>
              </div>
            </div>
            <!-- <lib-radio hidden [options]="timelineOptions" formControlName="timeline"></lib-radio> -->
          </div>
        </div>
        <span class="lib-spacer"></span>
        <nav class="lib-nav">
          <span class="lib-spacer"></span>
          <button type="button" class="lib-button-flat-primary"
            [disabled]="bookACallForm.get('timeline').value === '0,-1'" (click)="onBookACallStep('timeline')">
            <span>Next</span>
            <lib-icon name="chevronRight"></lib-icon>
          </button>
        </nav>
      </div>
      <div [hidden]="bookACallFormStep !== 'deposit'">
        <span class="lib-spacer"></span>
        <div>
          <h3>{{depositQuestion}}</h3>
          <p class="lib-legend">All you need is a 5% deposit to get started.</p>
          <div>
            <div class="timeline">
              <div class="input">
                <div *ngFor="let option of depositOptions; index as i" [hidden]="i === 0">
                  <input type="radio" [id]="'deposit'+i" name="deposit" formControlName="deposit"
                    [value]="option.value">
                </div>
              </div>
              <div class="line">
                <div *ngFor="let option of depositOptions; index as i" [hidden]="i === 0">
                  <label class="lib-legend" [for]="'deposit'+i">{{option.label}}</label>
                </div>
              </div>
            </div>
            <!-- <lib-radio hidden [options]="depositOptions" formControlName="deposit"></lib-radio> -->
          </div>
        </div>
        <span class="lib-spacer"></span>
        <nav class="lib-nav">
          <button type="button" class="lib-button-flat" (click)="bookACallFormStep = 'timeline'">
            <lib-icon name="chevronLeft"></lib-icon>
          </button>
          <span class="lib-spacer"></span>
          <button type="button" class="lib-button-flat-primary"
            [disabled]="bookACallForm.get('deposit').value === '0,-1'" (click)="onBookACallStep('deposit')">
            <span>Next</span>
            <lib-icon name="chevronRight"></lib-icon>
          </button>
        </nav>
      </div>
      <div [hidden]="bookACallFormStep !== 'home'">
        <span class="lib-spacer"></span>
        <div>
          <h3>{{homeQuestion}}</h3>
          <p class="lib-legend">Whether you've found a home you love or still looking, we can help</p>
          <div>
            <div class="timeline">
              <div class="input">
                <div *ngFor="let option of homeOptions; index as i" [hidden]="i === 0">
                  <input type="radio" [id]="'home'+i" name="home" formControlName="home"
                    [value]="option.value">
                </div>
              </div>
              <div class="line">
                <div *ngFor="let option of homeOptions; index as i" [hidden]="i === 0">
                  <label class="lib-legend" [for]="'home'+i">{{option.label}}</label>
                </div>
              </div>
            </div>
            <!-- <lib-radio hidden [options]="depositOptions" formControlName="deposit"></lib-radio> -->
          </div>
        </div>
        <span class="lib-spacer"></span>
        <nav class="lib-nav">
          <button type="button" class="lib-button-flat" (click)="bookACallFormStep = 'deposit'">
            <lib-icon name="chevronLeft"></lib-icon>
          </button>
          <span class="lib-spacer"></span>
          <button type="button" class="lib-button-flat-primary" [disabled]="bookACallForm.get('home').value === '0,-1'"
            (click)="onBookACallStep('home')">
            <span>Next</span>
            <lib-icon name="chevronRight"></lib-icon>
          </button>
        </nav>
      </div>
      <div class="book-a-call-container" [hidden]="bookACallFormStep !== 'book-a-call'" #bookCallContainer>
        <lib-book-a-call organization="proportunity" room="chat-with-us" (event)="onBookACallEvent($event)">
        </lib-book-a-call>
        <nav class="lib-nav">
          <button type="button" class="lib-button-flat" (click)="bookACallFormStep = 'home'">
            <lib-icon name="chevronLeft"></lib-icon>
          </button>
          <span class="lib-spacer"></span>
        </nav>
      </div>
      <div [hidden]="bookACallFormStep !== 'call-us'">
        <span class="lib-spacer"></span>
        <div>
          <h3>Let's get your home-buying journey started! </h3>
          <p>Give one of our friendly Proportunity experts a call on <a class="lib-button-stroked-link" href="tel:00442039622051" pTrackEvent="click"
              pTrackAction="direct_call" pTrackCategory="www_book_a_call">
              <span>+44 (0) 20 3962 2051</span>
            </a></p>
          <p>We're open Monday to Friday, from 9:30am - 6:30pm.</p>
          <p>They'll go through everything you need to know, advise on the next steps and get you on your way to owning
            your own home.</p>
        </div>
        <span class="lib-spacer"></span>
        <nav class="lib-nav">
          <button type="button" class="lib-button-flat" (click)="bookACallFormStep = 'home'">
            <lib-icon name="chevronLeft"></lib-icon>
          </button>
          <span class="lib-spacer"></span>
          <button type="button" class="lib-button-stroked" (click)="onBookACallClose($event)">
            <span>Done</span>
          </button>
        </nav>
      </div>
    </form>
  </div>
</main>
